<template>
  <div class="user-course">
    <template v-if="listLength">
      <div class="user-df-title">已购课程</div>
      <div class="list flex fww">
        <course-card :item="course" class="course"
                     img-key="course_bigimg"
                     image-width="202"
                     hidden-audio
                     @detail="courseClick"
                     width="202"
                     image-height="114"
                     show-props="name,slot_end"
                     v-for="(course, j) in list" :key="j">
          <template #image="{item}">
            <div class="course-image-box">
              <i class="mine-ico poa audio img" v-show="item.format_id === 2"></i>
              <div class="status-3 poa w100 h100 t0 l0 flex jcc aic" v-show="+item.status === 3">
                <i class="mine-ico lost-time img"></i>
              </div>
              <label-tip label-type="vip" text="即将过期" radius-size="8" radius-type="8" class="status-2 poa t0 r0"
                         v-show="+item.status === 2"></label-tip>
            </div>
          </template>
          <template #slot_end="{item}">
            <div class="end-time">有效期至：{{Tools.formatDate(item.end_time, 'Y年M月D日')}}</div>
          </template>
        </course-card>
      </div>
      <df-page :total="total" :page-size="limits" :current="curr" @change="changePage" class="pt20"></df-page>
    </template>
    <template v-else-if="total === null">
      <mine-no-data to="/home/page/boutique"></mine-no-data>
    </template>
  </div>
</template>

<script>
  import Mixins from '../../mixins/mixins';
  import {mapGetters} from 'vuex';

  export default {
    name: "UserCourse",
    // mixins: [Mixins.AppScroll()],
    components: {},
    computed: {
      ...mapGetters(['userInfo']),
      isAllLoad() {
        return this.listLength >= this.total && this.total;
      },
      listLength() {
        return this.list.length;
      },
    },
    data() {
      return {
        list: [],
        curr: 1,
        limits: 20,
        total: 0,
        isLoading: false,
      };
    },
    // appScroll(e) {
    //   let {height} = e.target.getBoundingClientRect();
    //   let {bottom} = this.$el.getBoundingClientRect();
    //   if (bottom - height / 3 < height && !this.isAllLoad && !this.isLoading) {
    //     this.curr++;
    //     this.getList();
    //   }
    // },
    created() {
      this.getList(1);
    },
    methods: {
      changePage(val, prop){
        if(this.curr === val) return;
        this.curr = val;
        this.getList();
      },
      courseClick(item) {
        this.OpenRouter({
          path: (item.format_id === 2 ? '/home/audio/details/' : '/home/video/details/') + item.id + '/3',
          query: {
            rid: item.resource_id,
          }
        });
      },
      getList(init) {
        if(!this.userInfo.uid) return;
        if (this.isLoading) return;
        this.isLoading = true;
        if (init) {
          this.curr = 1;
        }
        this.http.list({
          uid: this.userInfo.uid,
          ...this.Product,
          curr: this.curr,
          limits: this.limits,
        }).then(res => {
          if (this.curr === 1) {
            this.list = [];
          }
          this.total = res.total || null;
          this.list = res.list;
        }).catch(this.$err).finally(() => {
          this.isLoading = false;
					//当删除完当页数据，导致查询数据为空是，查询上一页数据
					if(this.total &&this.curr>1 && !this.list.length){
						this.curr--;
						this.getList();
						return
					}
        })

      },
    }
  }
</script>

<style scoped lang="less">
  .course-image-box {
    .audio {
      left: 8px;
      bottom: 5px;
    }
    .status-3 {
      background-color: rgba(0, 15, 34, .5);
    }
    .status-2 {
      font-size: 12px;
      line-height: 20px;
      background: #f16a2b;
    }
    /deep/ .vip {
      display: block;
    }
  }

  .user-course {
    padding: 16px 18px;
  }

  .list {
    margin-left: -16px;
  }

  .course {
    margin: 0 0 16px 16px;
    /deep/ .detail-box {
      padding: 0;
      width: 100%;
      .name {
        &:hover {
          color: #1177ff;
        }
      }
    }
    &:hover {
      /deep/ .name {
        color: #333f4e;
      }
    }
    .end-time {
      margin-top: 10px;
      font-size: 12px;
      color: #999fa6;
    }
  }
</style>